import React, { useState, useEffect } from "react";
import heroLiquor from "../assets/hero-liquor.jpg";

export default function Home() {
  // State for cookie consent banner
  const [showCookieBanner, setShowCookieBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShowCookieBanner(true);
    }
  }, []);

  const handleAcceptCookies = () => {
    localStorage.setItem("cookieConsent", "true");
    setShowCookieBanner(false);
  };

  const handleCookieSettings = () => {
    alert("Open detailed Privacy & Cookie Settings here.");
    // You can replace this alert with a modal or dedicated settings page
  };

  return (
    <div className="relative">
      {/* Cookie Consent Banner */}
      {showCookieBanner && (
        <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-white border shadow-lg p-6 rounded-lg w-11/12 max-w-lg z-50">
          <p className="text-gray-800 mb-4">
            We use cookies to enhance your browsing experience. By continuing, you agree to our use of cookies.
          </p>
          <div className="flex justify-end gap-3">
            <button
              onClick={handleCookieSettings}
              className="px-4 py-2 rounded-lg border border-gray-400 text-gray-700 hover:bg-gray-100 transition"
            >
              Privacy & Settings
            </button>
            <button
              onClick={handleAcceptCookies}
              className="px-4 py-2 rounded-lg bg-[#f4b942] text-black font-semibold hover:bg-[#ffcc66] transition"
            >
              Accept
            </button>
          </div>
        </div>
      )}

      {/* Hero Section */}
      <section className="relative h-[70vh] flex flex-col justify-center items-center text-center text-white bg-gradient-to-br from-[#2a0a1b] via-[#4b1127] to-[#7a1e33] overflow-hidden">
        <img
          src={heroLiquor}
          alt="Liquor bottles"
          className="absolute inset-0 w-full h-full object-cover opacity-30"
        />
        <h1 className="text-5xl font-extrabold z-10">Sip, Savor, Celebrate</h1>
        <p className="z-10 mt-4 text-lg max-w-xl">
          Discover world-class wines, spirits, and craft collections curated for indulgence.
        </p>
        <div className="mt-6 flex gap-4 z-10">
          <button className="bg-[#f4b942] text-black px-6 py-3 rounded-full font-semibold hover:bg-[#ffcc66] transition">
            Explore Deals
          </button>
          <button className="border border-[#f4b942] text-white px-6 py-3 rounded-full hover:bg-[#f4b942]/10 transition">
            View Collections
          </button>
        </div>
      </section>

      {/* Other Sections */}
      <section className="p-10">
        <h2 className="text-gray-700 text-3xl font-bold mb-4">Our Featured Collections</h2>
        <p className="text-gray-700">Coming soon...</p>
      </section>
    </div>
  );
}
